{
  "appName": "Hylo",
  "projectExternal": "External",
  "projectDashboardCount": "Dashboard {{count}}",
  "projectDashboardLabel_one": "{{count}} dashboard",
  "projectDashboardLabel_other": "{{count}} dashboards",
  "conversationNames": { "notes": "Notes", "group": "Group", "direct": "Direct message", "deleted": "Deleted account", "unknown": "Unknown" },
  "ok": "OK",
  "cancel": "Cancel",
  "done": "Done",
  "close": "Close",
  "save": "Save",
  "edit": "Edit",
  "delete": "Delete",
  "retry": "Retry",
  "back": "Back",
  "search": "Search",
  "loading": "Loading…",
  "unsupportedContent": "This message needs a newer version of Hylo."
}
